export default __webpack_public_path__ + "static/media/medical.5a3c1175.jpg";